import { generateUtilityClass, generateUtilityClasses } from '@mui/core';
export function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = generateUtilityClasses('MuiListItemSecondaryAction', ['root', 'disableGutters']);
export default listItemSecondaryActionClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/ListItemSecondaryAction/listItemSecondaryActionClasses.js
// module id = 782
// module chunks = 0